import { queryOptions } from "@tanstack/react-query";
import { backendApiV2 } from "../backendApi";

export const userInfoQueryOpts = () => {
  return queryOptions({
    queryKey: ["USER_INFO_V2"],
    queryFn: async () => {
      const resp = await backendApiV2.getUserInfo();
      return resp.data;
    },
  });
};
